module.exports = __webpack_public_path__ + "2ed972a065cbff85ffc0a021d8484559.svg";